import React from "react";
import PremiumResourcePage, { resourceMoney } from "../../../Components/Dashboard/PremiumResourcePage";
import PurchaseOrderUpdate from "./PurchaseOrderUpdate";

function PurchaseOrder({ navigation }) {
  return (
    <PremiumResourcePage
      navigation={navigation}
      title="Purchase Orders"
      subtitle="Track vendor purchase orders and delivery destinations."
      createRoute="PurchaseOrderNew"
      createLabel="+ New Purchase Order"
      fetchEndpoint="/fetchPurchaseOrder"
      fetchBody={{ fromDate: "", toDate: "" }}
      documentType="purchase_order"
      deleteEndpoint="/deleteByPurchaseNumber/:id"
      deleteKey="purchaseNumber"
      totalKey="total"
      renderEdit={(row, handleCancel) => (
        <PurchaseOrderUpdate
          purchaseOrderNumber={row.purchaseNumber}
          fetchedStatus={row.status}
          handleCancel={handleCancel}
        />
      )}
      columns={[
        { key: "purchaseDate", label: "Date" },
        {
          key: "purchaseNumber",
          label: "Purchase Order #",
          render: (row) => (
            <button className="premium-link" type="button">
              {row.purchaseNumber || "-"}
            </button>
          ),
        },
        { key: "vendorName", label: "Vendor Name" },
        { key: "total", label: "Amount", className: "premium-money", render: (row) => resourceMoney(row.total) },
        { key: "deliverTo", label: "Deliver To" },
      ]}
    />
  );
}

export default PurchaseOrder;
